import { createContext, useContext, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const RoomsContext = createContext();

export const RoomsProvider = ({ children }) => {
  const navigate = useNavigate(); 
  
  const [rooms, setRooms] = useState(async () => {
    await fetch('https://cdn.qrd.io/assets-abeille/rooms.json')
      .then((res) => res.json())
      .then((value) => setRooms(value.rooms))
      .catch((err) => {
        navigate('/error', { replace: true });
      });
  });

  const value = useMemo(() => ({ rooms }), [rooms]);

  return <RoomsContext.Provider value={value}>{children}</RoomsContext.Provider>;
};

export const useRooms = () => {
  return useContext(RoomsContext);
};
